var map = {
	"./berlin-2019.jpg": "V7+y",
	"./berlin-night.jpg": "AiwR",
	"./brno-2025.jpg": "iGk6",
	"./hamburg-2019.jpg": "gaLt",
	"./holguin-2020.jpg": "SCqw",
	"./istanbul-2026.jpg": "gJBK",
	"./naples-2017.jpg": "kg+E",
	"./naples-2018.jpg": "bWxJ",
	"./ostrava-2026.jpg": "paEF",
	"./prague-2024.jpg": "Qmkp",
	"./remote-2020.jpg": "iMV6",
	"./warsaw-2026.png": "ZVyB"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "o8cZ";